'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var createLock = require('./utils/create-lock.js');

var isIpfs = require('is-ipfs');

var stat = require('./stat.js');

var chmod = require('./chmod.js');

var cp = require('./cp.js');

var flush = require('./flush.js');

var mkdir = require('./mkdir.js');

var mv = require('./mv.js');

var rm = require('./rm.js');

var touch = require('./touch.js');

var read = require('./read.js');

var write = require('./write.js');

var ls = require('./ls.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var isIpfs__default = /*#__PURE__*/_interopDefaultLegacy(isIpfs);

var readOperations = {
  stat: stat.createStat
};
var writeOperations = {
  chmod: chmod.createChmod,
  cp: cp.createCp,
  flush: flush.createFlush,
  mkdir: mkdir.createMkdir,
  mv: mv.createMv,
  rm: rm.createRm,
  touch: touch.createTouch
};
var unwrappedOperations = {
  write: write.createWrite,
  read: read.createRead,
  ls: ls.createLs
};

var wrap = function wrap(_ref2) {
  var options = _ref2.options,
      mfs = _ref2.mfs,
      operations = _ref2.operations,
      lock = _ref2.lock;
  Object.keys(operations).forEach(function (key) {
    mfs[key] = lock(operations[key](options));
  });
};

var defaultOptions = {
  repoOwner: true,
  repo: null
};

function createMfs(options) {
  var _Object$assign = Object.assign({}, defaultOptions || {}, options),
      repoOwner = _Object$assign.repoOwner;

  var lock = createLock.createLock(repoOwner);

  var readLock = function readLock(operation) {
    return lock.readLock(operation);
  };

  var writeLock = function writeLock(operation) {
    return lock.writeLock(operation);
  };

  var mfs = {};
  wrap({
    options: options,
    mfs: mfs,
    operations: readOperations,
    lock: readLock
  });
  wrap({
    options: options,
    mfs: mfs,
    operations: writeOperations,
    lock: writeLock
  });
  Object.keys(unwrappedOperations).forEach(function (key) {
    mfs[key] = unwrappedOperations[key](options);
  });
  return mfs;
}

function createFiles(_ref3) {
  var repo = _ref3.repo,
      preload = _ref3.preload,
      hashers = _ref3.hashers,
      constructorOptions = _ref3.options;
  var methods = createMfs({
    repo: repo,
    repoOwner: Boolean(constructorOptions.repoOwner),
    hashers: hashers
  });

  var withPreload = function withPreload(fn) {
    var wrapped = function wrapped() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var paths = args.filter(function (arg) {
        return isIpfs__default["default"].ipfsPath(arg) || isIpfs__default["default"].cid(arg);
      });

      if (paths.length) {
        var options = args[args.length - 1];

        if (options && options.preload !== false) {
          paths.forEach(function (path) {
            return preload(path);
          });
        }
      }

      return fn.apply(void 0, args);
    };

    return wrapped;
  };

  return _objectSpread(_objectSpread({}, methods), {}, {
    chmod: methods.chmod,
    cp: withPreload(methods.cp),
    mkdir: methods.mkdir,
    stat: withPreload(methods.stat),
    rm: methods.rm,
    read: withPreload(methods.read),
    touch: methods.touch,
    write: methods.write,
    mv: withPreload(methods.mv),
    flush: methods.flush,
    ls: withPreload( /*#__PURE__*/function () {
      var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iteratorAbruptCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            file,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 2;
                _iterator = _asyncIterator(methods.ls.apply(methods, _args));

              case 4:
                _context.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 13;
                  break;
                }

                file = _step.value;
                _context.next = 10;
                return _objectSpread(_objectSpread({}, file), {}, {
                  size: file.size || 0
                });

              case 10:
                _iteratorAbruptCompletion = false;
                _context.next = 4;
                break;

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 19:
                _context.prev = 19;
                _context.prev = 20;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 24;
                return _awaitAsyncGenerator(_iterator.return());

              case 24:
                _context.prev = 24;

                if (!_didIteratorError) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(19);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }())
  });
}

exports.createFiles = createFiles;